var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: { subMenuItemMobileMenu: true, "close-panel": !_vm.disabled },
      attrs: { disabled: _vm.disabled },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _vm.labelId && _vm.labelId !== ""
        ? _c("span", [_vm._v(_vm._s(_vm.$t(_vm.labelId)))])
        : _c("span", [_vm._v(_vm._s(_vm.label))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }